import { render, staticRenderFns } from "./option-edit.vue?vue&type=template&id=375d5f5c&scoped=true"
import script from "./option-edit.vue?vue&type=script&lang=ts"
export * from "./option-edit.vue?vue&type=script&lang=ts"
import style0 from "./option-edit.vue?vue&type=style&index=0&id=375d5f5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375d5f5c",
  null
  
)

export default component.exports